export default __webpack_public_path__ + "static/media/pass_bg.c532761b.png";